export default __webpack_public_path__ + "static/media/upload_icon.c94d7ca2.svg";